var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoBlock',{attrs:{"title":_vm.title}},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.formatted.day)+" "+_vm._s(_vm.formatted.date))])]),_c('div',[_c('b',[_vm._v("from "+_vm._s(_vm.formatted.from)+" to "+_vm._s(_vm.formatted.to))])])])}
var staticRenderFns = []

export { render, staticRenderFns }